import { WIDGET_KINDS, parseWidgetInstance } from "@ever-tutor/et-widgets/core";
import {
  WIDGET_SHAPE_TYPE,
  widgetActionResults,
  type WidgetShape,
} from "@ever-tutor/et-widgets/tldraw";
import type { WidgetsPart } from "../../shared/types/PromptPart";
import { PromptPartUtil, registerPromptPartUtil } from "./PromptPartUtil";

export const WidgetsPartUtil = registerPromptPartUtil(
  class WidgetsPartUtil extends PromptPartUtil<WidgetsPart> {
    static override type = "widgets" as const;
    override getPart(): WidgetsPart {
      const items: WidgetsPart["items"] = [];
      for (const shape of this.editor.getCurrentPageShapesSorted()) {
        if (shape.type !== WIDGET_SHAPE_TYPE) continue;
        const bounds = this.editor.getShapePageBounds(shape);
        if (!bounds) continue;
        const widget = shape as WidgetShape;
        let instance: unknown = widget.props.instance;
        try {
          instance = parseWidgetInstance(instance);
        } catch (error) {
          console.error("Widget context unavailable", shape.id, error);
        }
        // Keep unreadable state on the wire: omission means deletion to the gateway.
        items.push({
          shapeId: shape.id,
          ref:
            typeof shape.meta.widgetRef === "string"
              ? shape.meta.widgetRef
              : shape.id.slice(6),
          bounds: { x: bounds.x, y: bounds.y, w: bounds.w, h: bounds.h },
          ...(typeof shape.meta.widgetUpdateId === "string"
            ? { tutorUpdateId: shape.meta.widgetUpdateId }
            : {}),
          instance,
        });
      }
      return {
        type: "widgets",
        supportedKinds: WIDGET_KINDS,
        actionResults: widgetActionResults(this.editor),
        items,
      };
    }
  },
);
